import Dispatch from '../components/modules/dispatch/index';

const consignee = [
  {
    path: '/track/:orderId/:trackId',
    name: 'Dispatch',
    component: Dispatch,
  },
];

export default consignee;
